import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { tap, delay } from 'rxjs';
import { PagingData } from '../models';
import { Product } from '../models/catalog.model';
import { ProductService } from '../services';
import { AmmIconCategory } from '../../components.global';

export interface ProductInitState {
  isLoading: boolean;
  isLoadingMore: boolean;
  hasLoadingError: boolean;
  products: Product[];
  productTotalRecords: number;
  filterProductTotalRecords: number;
  currentSelectedCategories: AmmIconCategory[];
  filteredProducts: Product[];
}
export const initState: ProductInitState = {
  isLoading: true,
  isLoadingMore: false,
  hasLoadingError: false,
  products: [],
  productTotalRecords: 0,
  filterProductTotalRecords: 0,
  currentSelectedCategories: [],
  filteredProducts: [],
};

export const HomeProductStore = signalStore(
  {
    providedIn: 'root',
  },
  withState(initState),
  withMethods((store, productSrv = inject(ProductService)) => ({
    setIsLoading() {
      patchState(store, { isLoading: true, hasLoadingError: false });
    },
    setIsLoadingMore() {
      patchState(store, { isLoadingMore: true, hasLoadingError: false });
    },
    loadSuccess() {
      patchState(store, { isLoading: false, hasLoadingError: false });
    },
    loadFailed() {
      patchState(store, { isLoading: false, hasLoadingError: true });
    },
    loadProducts(pageIndex: number, pageSize: number = 32) {
      let maxPageIndex=10;
      productSrv
        .getShuffledProducts('', '', pageIndex%maxPageIndex, pageSize)
        .pipe(delay(1000),tap(() => patchState(store, { isLoading: true })))
        .subscribe(
          (response: PagingData<Product>) => {
            if (response){
              maxPageIndex=response.totalPages||10;
            }
            if (response && response.dataList && response.dataList.length > 0) {
              patchState(store, {
                productTotalRecords: response.totalRecords,
              });
              if (pageIndex != 0) {
                patchState(store, {
                  isLoading: false,
                  isLoadingMore: false,
                  products: store.products().concat(response.dataList),
                });
              } else {
                patchState(store, {
                  isLoading: false,
                  isLoadingMore: false,
                  products: response.dataList,
                  currentSelectedCategories: []
                });
              }
            } else {
              patchState(store, {
                isLoading: false,
                isLoadingMore: false
              });
            }
          },
          (err) => {
            // console.log(err);
            patchState(store, {
              isLoading: false,
              isLoadingMore: false,
              hasLoadingError: true,
              products: [],
              productTotalRecords: 0,
              currentSelectedCategories: []
            });
          },
        );
    },
    loadFilterProducts(pageIndex: number, pageSize: number = 32, selectCategory: AmmIconCategory) {
      let updatedCategories: AmmIconCategory[] = [];

      const currentCategories = store.currentSelectedCategories();
      const isCategorySelected = currentCategories.some(cat => cat.id === selectCategory.id);

      if (isCategorySelected) {
        if (pageIndex != 0) {
          updatedCategories = currentCategories
        } else {
          selectCategory.selected = false;
          updatedCategories = [];
        }

      } else {
        selectCategory.selected = true;
        if (currentCategories.length > 0) {
          store.currentSelectedCategories()[0].selected = false;
        }
        updatedCategories = [selectCategory];
      } 
      patchState(store, {currentSelectedCategories: updatedCategories});

      if (updatedCategories.length == 0) {
        patchState(store, {
          isLoading: false, 
          isLoadingMore: false,
          filteredProducts: [],
          filterProductTotalRecords: 0
        });
        return;
      }

      let filterConditions: string = `&categories=${updatedCategories[0].id}`;

      productSrv
        .getProducts('', filterConditions, pageIndex, pageSize)
        .pipe(delay(1000),tap(() => {
          if (pageIndex != 0) {
            patchState(store, { isLoadingMore: true })
          } else {
            patchState(store, { isLoading: true })
          }
        }))
        .subscribe(
          (response: PagingData<Product>) => {
            if (response && response.dataList) {
              if (pageIndex != 0) {
                patchState(store, {
                  isLoadingMore: false,
                  filteredProducts: store.filteredProducts().concat(response.dataList),
                });
              } else {
                patchState(store, {
                  isLoading: false,
                  filteredProducts: response.dataList,
                  filterProductTotalRecords: response.totalRecords
                });
              }
            } else {
              patchState(store, (pageIndex != 0) ? {isLoadingMore: false} : {isLoading: false});
            }
          },
          (err) => {
            patchState(store, {
              isLoading: false,
              isLoadingMore: false,
              hasLoadingError: true,
              filteredProducts: [],
              filterProductTotalRecords: 0
            });
          },
        );
    },

  })),
);
